import { AuditDto, AuditStatus } from '../../../api';
import { FormParserService } from '../../../services/form-parser-service/form-parser.service';

/**
 * DOCU-1220: one row of the documentation list from `GET /api/v1/audit/list`.
 *
 * Hand-written (endpoint not yet in the generated client, same pattern as
 * reassignOwner/DOCU-675). Unlike AuditDto it carries neither the form snapshot
 * nor the entries: the server derives form name, `_title`, `_subtitle` and
 * `_folderLabel1` and sends only the `_` keys of the metaData. The detail view
 * loads the full audit via `GET /api/v1/audit/{id}`.
 */
export interface AuditListItemDto {
  id: string;
  metaData?: { [key: string]: any };
  userId?: string;
  user?: { firstname?: string; lastname?: string } | null;
  date?: string;
  status?: AuditStatus;
  formId?: string;
  formName?: string;
  knownServerUpdatedAt?: string | null;
  lastModifiedAt?: string | null;
}

function storedValue(item: AuditListItemDto, key: string): string {
  const value = item.metaData?.[key];
  return value == null ? '' : String(value).trim();
}

export function listItemTitle(item: AuditListItemDto): string {
  return storedValue(item, '_title');
}

export function listItemSubtitle(item: AuditListItemDto): string {
  return storedValue(item, '_subtitle');
}

/** Reduces a full audit (detail/create responses) to a list row. */
export function toListItem(audit: AuditDto): AuditListItemDto {
  const parser = new FormParserService();
  const metaData: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(audit.metaData ?? {})) {
    if (key.startsWith('_')) metaData[key] = value;
  }
  metaData['_title'] = parser.getTitle(audit);
  metaData['_subtitle'] = parser.getSubtitle(audit);
  return {
    id: audit.id!,
    metaData,
    userId: audit.userId,
    user: audit.user ? { firstname: audit.user.firstname, lastname: audit.user.lastname } : null,
    date: audit.date,
    status: audit.status,
    formId: audit.formId,
    formName: parser.getFormName(audit.form),
    knownServerUpdatedAt: audit.knownServerUpdatedAt,
    lastModifiedAt: audit.lastModifiedAt,
  };
}
